import { useIntl } from 'react-intl';

import WorkOrdersListModal from '@/components/_common/WorkOrdersListModal';
import { useDisclosure } from '@/hooks';
import { WorkOrderComplementStatusNumber } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';
import {
  StatisticDashboardModule,
  StatisticDashboardTypeColor,
} from '@/components/_common/StatisticDashboard';
import DashboardStatisticCard from '../../DashboardStatisticCard';
import formatterPrice from '@/utils/number/formatterPrice';

interface Props {
  value?: number;
}

function TotalWorkOrderAverageTicket({ value }: Props) {
  const intl = useIntl();
  const [viewWorkOrdersOpen, viewWorkOrdersActions] = useDisclosure();

  return (
    <>
      <DashboardStatisticCard
        tooltipTitle="Essa métrica é obtida dividindo o valor total dos orçamentos fechados pela quantidade desses orçamentos."
        statisticTitle={intl.formatMessage({
          id: 'dashboard.totalWorkOrderAverageTicket',
        })}
        color={StatisticDashboardTypeColor.info}
        value={formatterPrice(value || 0)}
        module={StatisticDashboardModule.workOrder}
        onClick={viewWorkOrdersActions.open}
      />

      <WorkOrdersListModal
        open={viewWorkOrdersOpen}
        onCancel={viewWorkOrdersActions.close}
        queryFilter={{
          status: [WorkOrderComplementStatusNumber.Closed],
          onlyFirstComplements: true,
        }}
      />
    </>
  );
}

export default TotalWorkOrderAverageTicket;
